// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.issues_spinnerBox__6h9vQ{
    transform: rotate(46deg);
    display: flex;
    justify-content: center;
    align-items: center;
    width: 80px;
    height: 80px;
    border-radius: 50%;
}
.issues_spinnerBox__6h9vQ p{
    transform: rotate(-47deg);
    font-size: 15px;
    font-weight: bold;
}
.issues_spinnerBox2__bKeF5{
    width: 50px;
    height: 50px;
    border-radius: 50%;
    border-width: 15px 16px 16px;
    border-style: solid;
    border-color: blue rgb(243, 243, 243) rgb(243, 243, 243);
    border-image: initial;
}

.issues_colourCode__EINu8{
    width: 20px;
    height: 20px;
    background-color: rebeccapurple;
}

.issues_mobileBoxes__wpLVr{
    width: 45%;
    box-shadow: grey 3px 3px 6px 1px;
    border: 1px solid grey;
    border-radius: 10px;
    background: white;
}

.issues_mobileBoxes__wpLVr .issues_counti__DHIsl {
    font-size: 29px;
    color: black;
    font-weight: bold;
    /* margin: 0.25rem 0rem; */
}

.issues_ticketlist__7rog6{
    width: 100%;
}
.issues_countmain__ZEYuC{
    width: 100%;
}

.issues_graphmain__pAUvy{
    width: 100%;
}

.issues_main__qsnF6{
    flex-direction: column;
}

.issues_piechart__nmaRt{
    display: flex;
    height: 200px;


}

@media (min-width: 768px) {
    .issues_ticketlist__7rog6{
        width: 63%;
    }
    .issues_countmain__ZEYuC{
        width: 35%;
    }
}

@media screen  and (max-width: 426px){
    .issues_graphmain__pAUvy{
        width: 100%;
    }

    .issues_piechart__nmaRt{
        display: none;
    }


}

.issues_fixed_width__6TMiu {
    width: 100%; 
}

/* .search_filter {
    overflow: auto;
} */

.issues_search_filter__SPpBK::-webkit-scrollbar {
    width: 3px;
    height: 3px;
}

.issues_search_filter__SPpBK::-webkit-scrollbar-track {
    background: #f1f1f1; 
    border-radius: 1rem; 
}

.issues_search_filter__SPpBK::-webkit-scrollbar-thumb {
    background-color: #007bff;
    border-radius: 1rem;
}

/* =========================================================
   Premium redesign additions
   ========================================================= */
.issues_panelHeader__NdfR7 {
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 12px;
  padding-bottom: 14px;
  border-bottom: 1px solid #EEF0F6;
  margin-bottom: 14px;
}

.issues_panelTitle__MB0zF {
  font-family: 'Sora', 'Inter', sans-serif;
  font-size: 15px;
  font-weight: 700;
  color: #1F2430;
  margin: 0;
}

.issues_actionBtns__8A\\+DQ {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
}

.issues_ghostBtn__w6jgP {
  background: #F5F3FE;
  color: #4c2fb3;
  border: none;
  border-radius: 10px;
  font-size: 12.5px;
  font-weight: 700;
  padding: 8px 16px;
  cursor: pointer;
  white-space: nowrap;
  transition: background 0.15s ease;
}
.issues_ghostBtn__w6jgP:hover {
  background: #E7DEFB;
}
.issues_ghostBtn__w6jgP:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

.issues_filterSelect__gZVmv,
.issues_searchInput__MKBWA,
.issues_dateInput__6gXpe {
  padding: 9px 14px;
  border-radius: 10px;
  border: 1px solid #E5E7EB;
  font-size: 13px;
  background: #ffffff;
  width: 100%;
  transition: border-color 0.15s ease, box-shadow 0.15s ease;
}
.issues_filterSelect__gZVmv:focus,
.issues_searchInput__MKBWA:focus,
.issues_dateInput__6gXpe:focus {
  outline: none;
  border-color: #4c2fb3;
  box-shadow: 0 0 0 3px rgba(124, 92, 252, 0.15);
}

.issues_tableWrap__awBEP {
  overflow-x: auto;
}

.issues_tableWrap__awBEP .MuiTableCell-root {
  font-family: 'Inter', sans-serif;
  border-bottom: 1px solid #F1F2F6;
  padding: 10px 14px;
}
.issues_tableWrap__awBEP .MuiTableHead-root .MuiTableRow-root .MuiTableCell-root {
  background: #F5F3FE;
  color: #4c2fb3;
  text-transform: uppercase;
  letter-spacing: 0.04em;
  font-size: 11px;
  font-weight: 700;
  white-space: nowrap;
}
.issues_tableWrap__awBEP .MuiTableBody-root .MuiTableRow-root:hover .MuiTableCell-root {
  background: #FAF8FF;
}
.issues_tableWrap__awBEP .MuiPaper-root {
  box-shadow: none;
  border: 1px solid #EEF0F6;
  border-radius: 12px;
}

.issues_pillBase__sp-um {
  display: inline-flex;
  align-items: center;
  padding: 3px 12px;
  border-radius: 20px;
  font-size: 11.5px;
  font-weight: 700;
  white-space: nowrap;
}
.issues_pillGreen__c-8B6 { background: #E9F9EF; color: #16A34A; }
.issues_pillRed__CWHml { background: #FDEDED; color: #DC2626; }
.issues_pillAmber__1WLSc { background: #FFF7E6; color: #B45309; }

.issues_emptyState__FU6wH {
  text-align: center;
  color: #9CA3AF;
  font-size: 13.5px;
  padding: 40px 0;
  width: 100%;
}

.issues_paginationRow__dUOAi {
  display: flex;
  justify-content: center;
  margin-top: 16px;
}

.issues_pageList__oQdTC {
  display: flex;
  align-items: center;
  gap: 4px;
  list-style: none;
  padding: 0;
  margin: 0;
}

.issues_pageBtn__rj1SS {
  border: 1px solid #E5E7EB;
  background: #ffffff;
  color: #374151;
  font-size: 12.5px;
  font-weight: 600;
  padding: 6px 12px;
  border-radius: 8px;
  cursor: pointer;
  transition: background 0.15s ease, color 0.15s ease, border-color 0.15s ease;
}
.issues_pageBtn__rj1SS:hover:not(:disabled) {
  background: #F5F3FE;
  border-color: #C9BCF2;
  color: #4c2fb3;
}
.issues_pageBtn__rj1SS:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}
.issues_pageBtnActive__uanuE {
  background: linear-gradient(135deg, #4c2fb3 0%, #7c5cfc 100%);
  border-color: transparent;
  color: #ffffff;
}
.issues_pageBtnActive__uanuE:hover {
  color: #ffffff !important;
}
.issues_pageEllipsis__5yYRA {
  color: #9CA3AF;
  font-size: 12.5px;
  padding: 0 4px;
}

.issues_statsGrid__2arl- {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 14px;
}

.issues_statTile__iQC2P {
  display: flex;
  flex-direction: column;
  gap: 6px;
  padding: 16px;
  border-radius: 14px;
  border: 1px solid #EEF0F6;
  background: #FAFAFD;
}

.issues_statIconWrap__4DVzC {
  width: 32px;
  height: 32px;
  border-radius: 9px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.issues_statCount__3gHK7 {
  font-family: 'Sora', 'Inter', sans-serif;
  font-size: 24px;
  font-weight: 700;
  color: #1F2430;
  margin: 0;
}

.issues_statLabel__0wR0k {
  font-size: 12px;
  color: #6B7280;
  font-weight: 600;
  margin: 0;
}

.issues_legendRow__0TCY1 {
  display: flex;
  justify-content: center;
  gap: 20px;
  margin-top: 8px;
}

.issues_legendItem__11XY9 {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 12.5px;
  color: #374151;
}

.issues_legendDot__pqMB3 {
  width: 12px;
  height: 12px;
  border-radius: 50%;
}

.issues_modalBox__lrxDW {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 100%;
  max-width: 460px;
  background: #ffffff;
  border-radius: 16px;
  box-shadow: 0 20px 60px rgba(17, 12, 46, 0.25);
  overflow: hidden;
  outline: none;
}

.issues_modalHeader__xdcoQ {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 16px 22px;
  border-bottom: 1px solid #EEF0F6;
  font-weight: 700;
  font-size: 14.5px;
  color: #1F2430;
  font-family: 'Sora', 'Inter', sans-serif;
}

.issues_modalCloseBtn__tidBx {
  cursor: pointer;
  color: #9CA3AF;
  display: flex;
  align-items: center;
}
.issues_modalCloseBtn__tidBx:hover {
  color: #4c2fb3;
}

.issues_modalBody__6uUFG {
  padding: 20px 22px;
}

.issues_modalFooter__TJkEj {
  display: flex;
  justify-content: flex-end;
  gap: 12px;
  padding: 16px 22px;
  border-top: 1px solid #EEF0F6;
}
`, "",{"version":3,"sources":["webpack://./src/pages/igm_portal/Issues/issues.module.css"],"names":[],"mappings":"AAAA;IACI,wBAAwB;IACxB,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,WAAW;IACX,YAAY;IACZ,kBAAkB;AACtB;AACA;IACI,yBAAyB;IACzB,eAAe;IACf,iBAAiB;AACrB;AACA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,4BAA4B;IAC5B,mBAAmB;IACnB,wDAAwD;IACxD,qBAAqB;AACzB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,+BAA+B;AACnC;;AAEA;IACI,UAAU;IACV,gCAAgC;IAChC,sBAAsB;IACtB,mBAAmB;IACnB,iBAAiB;AACrB;;AAEA;IACI,eAAe;IACf,YAAY;IACZ,iBAAiB;IACjB,0BAA0B;AAC9B;;AAEA;IACI,WAAW;AACf;AACA;IACI,WAAW;AACf;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,aAAa;IACb,aAAa;;;AAGjB;;AAEA;IACI;QACI,UAAU;IACd;IACA;QACI,UAAU;IACd;AACJ;;AAEA;IACI;QACI,WAAW;IACf;;IAEA;QACI,aAAa;IACjB;;;AAGJ;;AAEA;IACI,WAAW;AACf;;AAEA;;GAEG;;AAEH;IACI,UAAU;IACV,WAAW;AACf;;AAEA;IACI,mBAAmB;IACnB,mBAAmB;AACvB;;AAEA;IACI,yBAAyB;IACzB,mBAAmB;AACvB;;AAEA;;8DAE8D;AAC9D;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,eAAe;EACf,SAAS;EACT,oBAAoB;EACpB,gCAAgC;EAChC,mBAAmB;AACrB;;AAEA;EACE,wCAAwC;EACxC,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,SAAS;AACX;;AAEA;EACE,aAAa;EACb,eAAe;EACf,QAAQ;AACV;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,YAAY;EACZ,mBAAmB;EACnB,iBAAiB;EACjB,gBAAgB;EAChB,iBAAiB;EACjB,eAAe;EACf,mBAAmB;EACnB,iCAAiC;AACnC;AACA;EACE,mBAAmB;AACrB;AACA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;;;EAGE,iBAAiB;EACjB,mBAAmB;EACnB,yBAAyB;EACzB,eAAe;EACf,mBAAmB;EACnB,WAAW;EACX,0DAA0D;AAC5D;AACA;;;EAGE,aAAa;EACb,qBAAqB;EACrB,8CAA8C;AAChD;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gCAAgC;EAChC,gCAAgC;EAChC,kBAAkB;AACpB;AACA;EACE,mBAAmB;EACnB,cAAc;EACd,yBAAyB;EACzB,sBAAsB;EACtB,eAAe;EACf,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,iBAAiB;EACjB,mBAAmB;EACnB,iBAAiB;EACjB,gBAAgB;EAChB,mBAAmB;AACrB;AACA,2BAAa,mBAAmB,EAAE,cAAc,EAAE;AAClD,yBAAW,mBAAmB,EAAE,cAAc,EAAE;AAChD,2BAAa,mBAAmB,EAAE,cAAc,EAAE;;AAElD;EACE,kBAAkB;EAClB,cAAc;EACd,iBAAiB;EACjB,eAAe;EACf,WAAW;AACb;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,UAAU;EACV,SAAS;AACX;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,cAAc;EACd,iBAAiB;EACjB,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,4EAA4E;AAC9E;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,cAAc;AAChB;AACA;EACE,YAAY;EACZ,mBAAmB;AACrB;AACA;EACE,6DAA6D;EAC7D,yBAAyB;EACzB,cAAc;AAChB;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,cAAc;EACd,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,wCAAwC;EACxC,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,SAAS;AACX;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,gCAAgC;EAChC,WAAW;EACX,gBAAgB;EAChB,mBAAmB;EACnB,mBAAmB;EACnB,8CAA8C;EAC9C,gBAAgB;EAChB,aAAa;AACf;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,kBAAkB;EAClB,gCAAgC;EAChC,gBAAgB;EAChB,iBAAiB;EACjB,cAAc;EACd,wCAAwC;AAC1C;;AAEA;EACE,eAAe;EACf,cAAc;EACd,aAAa;EACb,mBAAmB;AACrB;AACA;EACE,cAAc;AAChB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,SAAS;EACT,kBAAkB;EAClB,6BAA6B;AAC/B","sourcesContent":[".spinnerBox{\n    transform: rotate(46deg);\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    width: 80px;\n    height: 80px;\n    border-radius: 50%;\n}\n.spinnerBox p{\n    transform: rotate(-47deg);\n    font-size: 15px;\n    font-weight: bold;\n}\n.spinnerBox2{\n    width: 50px;\n    height: 50px;\n    border-radius: 50%;\n    border-width: 15px 16px 16px;\n    border-style: solid;\n    border-color: blue rgb(243, 243, 243) rgb(243, 243, 243);\n    border-image: initial;\n}\n\n.colourCode{\n    width: 20px;\n    height: 20px;\n    background-color: rebeccapurple;\n}\n\n.mobileBoxes{\n    width: 45%;\n    box-shadow: grey 3px 3px 6px 1px;\n    border: 1px solid grey;\n    border-radius: 10px;\n    background: white;\n}\n\n.mobileBoxes .counti {\n    font-size: 29px;\n    color: black;\n    font-weight: bold;\n    /* margin: 0.25rem 0rem; */\n}\n\n.ticketlist{\n    width: 100%;\n}\n.countmain{\n    width: 100%;\n}\n\n.graphmain{\n    width: 100%;\n}\n\n.main{\n    flex-direction: column;\n}\n\n.piechart{\n    display: flex;\n    height: 200px;\n\n\n}\n\n@media (min-width: 768px) {\n    .ticketlist{\n        width: 63%;\n    }\n    .countmain{\n        width: 35%;\n    }\n}\n\n@media screen  and (max-width: 426px){\n    .graphmain{\n        width: 100%;\n    }\n\n    .piechart{\n        display: none;\n    }\n\n\n}\n\n.fixed_width {\n    width: 100%; \n}\n\n/* .search_filter {\n    overflow: auto;\n} */\n\n.search_filter::-webkit-scrollbar {\n    width: 3px;\n    height: 3px;\n}\n\n.search_filter::-webkit-scrollbar-track {\n    background: #f1f1f1; \n    border-radius: 1rem; \n}\n\n.search_filter::-webkit-scrollbar-thumb {\n    background-color: #007bff;\n    border-radius: 1rem;\n}\n\n/* =========================================================\n   Premium redesign additions\n   ========================================================= */\n.panelHeader {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  flex-wrap: wrap;\n  gap: 12px;\n  padding-bottom: 14px;\n  border-bottom: 1px solid #EEF0F6;\n  margin-bottom: 14px;\n}\n\n.panelTitle {\n  font-family: 'Sora', 'Inter', sans-serif;\n  font-size: 15px;\n  font-weight: 700;\n  color: #1F2430;\n  margin: 0;\n}\n\n.actionBtns {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 8px;\n}\n\n.ghostBtn {\n  background: #F5F3FE;\n  color: #4c2fb3;\n  border: none;\n  border-radius: 10px;\n  font-size: 12.5px;\n  font-weight: 700;\n  padding: 8px 16px;\n  cursor: pointer;\n  white-space: nowrap;\n  transition: background 0.15s ease;\n}\n.ghostBtn:hover {\n  background: #E7DEFB;\n}\n.ghostBtn:disabled {\n  opacity: 0.6;\n  cursor: not-allowed;\n}\n\n.filterSelect,\n.searchInput,\n.dateInput {\n  padding: 9px 14px;\n  border-radius: 10px;\n  border: 1px solid #E5E7EB;\n  font-size: 13px;\n  background: #ffffff;\n  width: 100%;\n  transition: border-color 0.15s ease, box-shadow 0.15s ease;\n}\n.filterSelect:focus,\n.searchInput:focus,\n.dateInput:focus {\n  outline: none;\n  border-color: #4c2fb3;\n  box-shadow: 0 0 0 3px rgba(124, 92, 252, 0.15);\n}\n\n.tableWrap {\n  overflow-x: auto;\n}\n\n.tableWrap :global(.MuiTableCell-root) {\n  font-family: 'Inter', sans-serif;\n  border-bottom: 1px solid #F1F2F6;\n  padding: 10px 14px;\n}\n.tableWrap :global(.MuiTableHead-root .MuiTableRow-root .MuiTableCell-root) {\n  background: #F5F3FE;\n  color: #4c2fb3;\n  text-transform: uppercase;\n  letter-spacing: 0.04em;\n  font-size: 11px;\n  font-weight: 700;\n  white-space: nowrap;\n}\n.tableWrap :global(.MuiTableBody-root .MuiTableRow-root:hover .MuiTableCell-root) {\n  background: #FAF8FF;\n}\n.tableWrap :global(.MuiPaper-root) {\n  box-shadow: none;\n  border: 1px solid #EEF0F6;\n  border-radius: 12px;\n}\n\n.pillBase {\n  display: inline-flex;\n  align-items: center;\n  padding: 3px 12px;\n  border-radius: 20px;\n  font-size: 11.5px;\n  font-weight: 700;\n  white-space: nowrap;\n}\n.pillGreen { background: #E9F9EF; color: #16A34A; }\n.pillRed { background: #FDEDED; color: #DC2626; }\n.pillAmber { background: #FFF7E6; color: #B45309; }\n\n.emptyState {\n  text-align: center;\n  color: #9CA3AF;\n  font-size: 13.5px;\n  padding: 40px 0;\n  width: 100%;\n}\n\n.paginationRow {\n  display: flex;\n  justify-content: center;\n  margin-top: 16px;\n}\n\n.pageList {\n  display: flex;\n  align-items: center;\n  gap: 4px;\n  list-style: none;\n  padding: 0;\n  margin: 0;\n}\n\n.pageBtn {\n  border: 1px solid #E5E7EB;\n  background: #ffffff;\n  color: #374151;\n  font-size: 12.5px;\n  font-weight: 600;\n  padding: 6px 12px;\n  border-radius: 8px;\n  cursor: pointer;\n  transition: background 0.15s ease, color 0.15s ease, border-color 0.15s ease;\n}\n.pageBtn:hover:not(:disabled) {\n  background: #F5F3FE;\n  border-color: #C9BCF2;\n  color: #4c2fb3;\n}\n.pageBtn:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n.pageBtnActive {\n  background: linear-gradient(135deg, #4c2fb3 0%, #7c5cfc 100%);\n  border-color: transparent;\n  color: #ffffff;\n}\n.pageBtnActive:hover {\n  color: #ffffff !important;\n}\n.pageEllipsis {\n  color: #9CA3AF;\n  font-size: 12.5px;\n  padding: 0 4px;\n}\n\n.statsGrid {\n  display: grid;\n  grid-template-columns: repeat(2, 1fr);\n  gap: 14px;\n}\n\n.statTile {\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n  padding: 16px;\n  border-radius: 14px;\n  border: 1px solid #EEF0F6;\n  background: #FAFAFD;\n}\n\n.statIconWrap {\n  width: 32px;\n  height: 32px;\n  border-radius: 9px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.statCount {\n  font-family: 'Sora', 'Inter', sans-serif;\n  font-size: 24px;\n  font-weight: 700;\n  color: #1F2430;\n  margin: 0;\n}\n\n.statLabel {\n  font-size: 12px;\n  color: #6B7280;\n  font-weight: 600;\n  margin: 0;\n}\n\n.legendRow {\n  display: flex;\n  justify-content: center;\n  gap: 20px;\n  margin-top: 8px;\n}\n\n.legendItem {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  font-size: 12.5px;\n  color: #374151;\n}\n\n.legendDot {\n  width: 12px;\n  height: 12px;\n  border-radius: 50%;\n}\n\n.modalBox {\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  width: 100%;\n  max-width: 460px;\n  background: #ffffff;\n  border-radius: 16px;\n  box-shadow: 0 20px 60px rgba(17, 12, 46, 0.25);\n  overflow: hidden;\n  outline: none;\n}\n\n.modalHeader {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 16px 22px;\n  border-bottom: 1px solid #EEF0F6;\n  font-weight: 700;\n  font-size: 14.5px;\n  color: #1F2430;\n  font-family: 'Sora', 'Inter', sans-serif;\n}\n\n.modalCloseBtn {\n  cursor: pointer;\n  color: #9CA3AF;\n  display: flex;\n  align-items: center;\n}\n.modalCloseBtn:hover {\n  color: #4c2fb3;\n}\n\n.modalBody {\n  padding: 20px 22px;\n}\n\n.modalFooter {\n  display: flex;\n  justify-content: flex-end;\n  gap: 12px;\n  padding: 16px 22px;\n  border-top: 1px solid #EEF0F6;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"spinnerBox": `issues_spinnerBox__6h9vQ`,
	"spinnerBox2": `issues_spinnerBox2__bKeF5`,
	"colourCode": `issues_colourCode__EINu8`,
	"mobileBoxes": `issues_mobileBoxes__wpLVr`,
	"counti": `issues_counti__DHIsl`,
	"ticketlist": `issues_ticketlist__7rog6`,
	"countmain": `issues_countmain__ZEYuC`,
	"graphmain": `issues_graphmain__pAUvy`,
	"main": `issues_main__qsnF6`,
	"piechart": `issues_piechart__nmaRt`,
	"fixed_width": `issues_fixed_width__6TMiu`,
	"search_filter": `issues_search_filter__SPpBK`,
	"panelHeader": `issues_panelHeader__NdfR7`,
	"panelTitle": `issues_panelTitle__MB0zF`,
	"actionBtns": `issues_actionBtns__8A+DQ`,
	"ghostBtn": `issues_ghostBtn__w6jgP`,
	"filterSelect": `issues_filterSelect__gZVmv`,
	"searchInput": `issues_searchInput__MKBWA`,
	"dateInput": `issues_dateInput__6gXpe`,
	"tableWrap": `issues_tableWrap__awBEP`,
	"pillBase": `issues_pillBase__sp-um`,
	"pillGreen": `issues_pillGreen__c-8B6`,
	"pillRed": `issues_pillRed__CWHml`,
	"pillAmber": `issues_pillAmber__1WLSc`,
	"emptyState": `issues_emptyState__FU6wH`,
	"paginationRow": `issues_paginationRow__dUOAi`,
	"pageList": `issues_pageList__oQdTC`,
	"pageBtn": `issues_pageBtn__rj1SS`,
	"pageBtnActive": `issues_pageBtnActive__uanuE`,
	"pageEllipsis": `issues_pageEllipsis__5yYRA`,
	"statsGrid": `issues_statsGrid__2arl-`,
	"statTile": `issues_statTile__iQC2P`,
	"statIconWrap": `issues_statIconWrap__4DVzC`,
	"statCount": `issues_statCount__3gHK7`,
	"statLabel": `issues_statLabel__0wR0k`,
	"legendRow": `issues_legendRow__0TCY1`,
	"legendItem": `issues_legendItem__11XY9`,
	"legendDot": `issues_legendDot__pqMB3`,
	"modalBox": `issues_modalBox__lrxDW`,
	"modalHeader": `issues_modalHeader__xdcoQ`,
	"modalCloseBtn": `issues_modalCloseBtn__tidBx`,
	"modalBody": `issues_modalBody__6uUFG`,
	"modalFooter": `issues_modalFooter__TJkEj`
};
export default ___CSS_LOADER_EXPORT___;
